var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mi:location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0717 3.67847C13.9789 3.67847 7.35742 10.2999 7.35742 18.3928C7.35742 28.3249 20.2324 39.5445 20.7842 40.0963C21.1521 40.2803 21.7039 40.4642 22.0717 40.4642C22.4396 40.4642 22.9914 40.2803 23.3592 40.0963C23.911 39.5445 36.786 28.3249 36.786 18.3928C36.786 10.2999 30.1646 3.67847 22.0717 3.67847ZM22.0717 36.2338C18.2092 32.5553 11.036 24.6463 11.036 18.3928C11.036 12.3231 16.0021 7.35704 22.0717 7.35704C28.1414 7.35704 33.1074 12.3231 33.1074 18.3928C33.1074 24.4624 25.9342 32.5553 22.0717 36.2338ZM22.0717 11.0356C18.0253 11.0356 14.7146 14.3463 14.7146 18.3928C14.7146 22.4392 18.0253 25.7499 22.0717 25.7499C26.1181 25.7499 29.4289 22.4392 29.4289 18.3928C29.4289 14.3463 26.1181 11.0356 22.0717 11.0356ZM22.0717 22.0713C20.0485 22.0713 18.3931 20.416 18.3931 18.3928C18.3931 16.3695 20.0485 14.7142 22.0717 14.7142C24.0949 14.7142 25.7503 16.3695 25.7503 18.3928C25.7503 20.416 24.0949 22.0713 22.0717 22.0713Z",
    fill: "#256D9D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiLocation);
export default __webpack_public_path__ + "static/media/mi_location.c86dcd8e9525901a0f1752fc60541fae.svg";
export { ForwardRef as ReactComponent };